export const general = {
	languages: {
		en: "English",
		sv: "Swedish",
		da: "Danish",
		no: "Norwegian",
	},
};
